import PanelPosition from "./PanelPosition";
// import InverterStringLine from "../module/InverterStringLine";

export default class InverterString {
    id: number;
    invID: number;
    name: string;
    color: string;
    panelCount: number;
    panels: PanelPosition[];
    subGenName:string;
    nodes: any[]= []
    // stringLine: InverterStringLine;

    constructor(id: number, invID: number, panelCount: number, color: string, name: string, subName: string) {
        this.id = id;
        this.invID = invID;
        this.panelCount = panelCount;
        this.color = color;
        this.name = name;
        this.subGenName = subName;
    }
}
